import { PBR_HAS_EMISSIVE_COLOR, PBR2_HAS_UV_TRANSFORM, PBR_HAS_EMISSIVE } from '../pbr-flag-bits.js';

function createEmissiveColorFragment(hasEmissiveTexture, emissiveUV = "input.uv") {
  return {
    _id: "emissive-color",
    _uboFields: [
      { _name: "emissiveColor", _type: "vec3<f32>" },
      { _name: "_emissiveColorPad", _type: "f32" }
    ],
    _fragmentSlots: {
      AT: hasEmissiveTexture ? `emissive=material.emissiveColor*textureSample(emissiveTexture,emissiveSampler,${emissiveUV}).rgb;` : `emissive=material.emissiveColor;`
    }
  };
}
function writeEmissiveUBO(data, material, offsets) {
  if (!material._emissiveColor || !offsets.has("emissiveColor")) {
    return;
  }
  const off = offsets.get("emissiveColor") / 4;
  data[off] = material._emissiveColor[0];
  data[off + 1] = material._emissiveColor[1];
  data[off + 2] = material._emissiveColor[2];
}
const pbrExt = {
  id: "emissive-color",
  phase: "fragment",
  detect(mat) {
    return { f: mat._emissiveColor ? PBR_HAS_EMISSIVE_COLOR : 0, f2: 0 };
  },
  frag(ctx) {
    if (!(ctx._features & PBR_HAS_EMISSIVE_COLOR)) {
      return null;
    }
    const emissiveUV = ctx._features2 & PBR2_HAS_UV_TRANSFORM ? "emissiveUV" : (ctx._uv2Mask ?? 0) & 1 << 3 ? "input.uv2" : "input.uv";
    return createEmissiveColorFragment((ctx._features & PBR_HAS_EMISSIVE) !== 0, emissiveUV);
  },
  writeUbo: writeEmissiveUBO
};

export { createEmissiveColorFragment, pbrExt, writeEmissiveUBO };
//# sourceMappingURL=emissive-fragment.js.map
